<template>
  <div class="m-5 p-5 border-top flex-grow">
    <h1 class="mb-3">{{result.name}}</h1>
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/5 sm:w-1/1 h-100 ">
        <h6 class="my-4">Customer information</h6>
        <div class="vx-row"></div>
        <p>$70-100 pp/n</p>
        <p>45 years old</p>
        <p>Q1 booking time</p>
      </div>
      <div class="vx-col w-full lg:w-1/5 sm:w-1/1 h-100 ">
        <h6 class="my-4">Preferences</h6>
        <div class="vx-row">
          <div class="vx-col w-1/2 truncate">
            <div class="flex items-center">
              <feather-icon svgClasses="h-4 w-4 stroke-current text-primary" icon="PlusCircleIcon" class="mr-1"/><span>service</span>
            </div>
            <div class="flex items-center">
              <feather-icon svgClasses="h-4 w-4 stroke-current text-primary" icon="PlusCircleIcon" class="mr-1"/><span>food & drinks</span>
            </div>
            <div class="flex items-center">
              <feather-icon svgClasses="h-4 w-4 stroke-current text-primary" icon="PlusCircleIcon" class="mr-1"/><span>casino</span>
            </div>
          </div>
          <div class="vx-col w-1/2 truncate">
            <p>Carnival Cruises</p>
            <p>Australia</p>
            <p>Jan-Feb 2</p>
          </div>
        </div>

      </div>
      <div class="vx-col w-full lg:w-1/5 sm:w-1/1 h-100 ">
        <h6 class="my-4">Browsing History</h6>
        <p>5 nights Mexican Rivera
        <p>7 nights Western Caribbean</p>
        <p>4 nights Eastern Caribbean</p>
      </div>
      <div class="vx-col w-full lg:w-2/5 sm:w-1/1 h-100 ">
        <h6 class="my-4">Booking History</h6>
        <p>7 nights Alaska, Carnival Cruises, Jul 19, $6,200</p>
        <p>6 nights Caribbean Cruise, Royal Caribbean, Jan 19, $4,500</p>
        <p>4 Night Western Caribbean, Carnival Cruises, Feb 18, $2.500</p>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    result: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss">
  .border-top:before {
    content: "";
    top: 0;
    left: 0;
    position: absolute;
    width: 100%;
    height: 1px;
    background: rgba(0,0,0,.05);
  }
</style>